import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export const saveVoucher = (params = {}, pathParams: { voucherAction: string }) =>
    axios.post(`${API_URLS.CART}${pathParams.voucherAction}`, params);
